import { render, staticRenderFns } from "./vendorApproval.vue?vue&type=template&id=2af85ef0&scoped=true"
import script from "./vendorApproval.vue?vue&type=script&lang=js"
export * from "./vendorApproval.vue?vue&type=script&lang=js"
import style0 from "./vendorApproval.vue?vue&type=style&index=0&id=2af85ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af85ef0",
  null
  
)

export default component.exports